"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslationsDefinition = void 0;
const services_definitions_1 = require("@wix/services-definitions");
exports.TranslationsDefinition = (0, services_definitions_1.defineService)('viewer-core/translations');
//# sourceMappingURL=index.js.map